import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrea Antonello
 * id 4B4C339D-D581-44A3-95DE-4254CC42AC8D
 * name vector-point
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-point.svg
 * tags
 * - Vector 
 */
export const VectorPointIcon = createSvgIcon(<><path d="M9 9V15H15V9H9M11 11H13V13H11V11Z" /></>, 'VectorPointIcon');
export default VectorPointIcon